import type { PropsWithChildren } from "react";
import { createElement, forwardRef } from "react";

import type { IComponent } from "../Component";
import { defaultAttributes } from "../Component";

import * as css from "./Panel.module.css";

export interface IPanelTitleElement {
    h1: HTMLDivElement;
    h2: HTMLDivElement;
    h3: HTMLDivElement;
    h4: HTMLDivElement;
    h5: HTMLDivElement;
    h6: HTMLDivElement;
}

export enum TitleAlignment {
    Left,
    Center,
    Right,
}

export interface IPanel extends PropsWithChildren<IComponent> {
    title?: string;
    titleAlignment?: TitleAlignment;
    titleElement?: keyof IPanelTitleElement;
}

function getTitleAlignmentClassName(alignment?: TitleAlignment) {
    switch (alignment) {
        case TitleAlignment.Center:
            return css.center;
        case TitleAlignment.Right:
            return css.right;
        default:
            return css.left;
    }
}

export const Panel = forwardRef<HTMLDivElement, IPanel>((props: IPanel, passedRef) => (
    <div {...defaultAttributes(props, css.panelComponent)} ref={passedRef}>
        {props.title && (
            <header className={getTitleAlignmentClassName(props.titleAlignment)}>
                {createElement(props.titleElement || "h3", { className: css.titleText }, props.title)}
            </header>
        )}
        {props.children}
    </div>
));
